module.exports = __webpack_public_path__ + "img/qpay_white.0113bfd6.svg";